import { instance } from './api';

class DashboardService {
  async getPlotDataBasedOnLocation(payloads) {
    const { id, currentPage, pageSize } = payloads;

    const response = await instance.get(
      `user/plot/${id}?limit=${pageSize}&page=${currentPage}`,
    );
    return response.data;
  }

  async getPlantDetailsBasedOnPlot(payloads) {
    const { id, currentPage, pageSize } = payloads;
    const response = await instance.get(
      `user/plantationData/${id}?limit=${pageSize}&page=${currentPage}`,
    );
    return response.data;
  }

  async getMonitoringPlantList(payloads) {
    const { id, currentPage, pageSize } = payloads;

    const response = await instance.get(
      `user/monitoringPlant/${id}?limit=${pageSize}&page=${currentPage}`,
    );
    return response.data;
  }
  async getPlantGraphData(payload) {
    console.log(payload);
    const response = await instance.get(
      `user/graph?code=${payload.code}&minDate=${payload.minDate}&maxDate=${payload.maxDate}`,
    );
    return response.data;
  }
  async getPlotData(payload) {
    const response = await instance.get(`admin/getPlot/${payload}`);
    return response.data;
  }

  async getLocationById(payload) {
    const { id } = payload;

    const response = await instance.get(`admin/getAllLocations/${id}`);
    return response.data;
  }
}

export default new DashboardService();
